//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Page401',
  data: function data() {
    return {};
  },
  methods: {
    back: function back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({
          path: '/dashboard'
        });
      } else {
        this.$router.go(-1);
      }
    },
    handleReLogin: function handleReLogin() {
      this.$store.dispatch('user/handleLogout');
    }
  }
};